import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useTranslation } from "react-i18next";
import { MessageCircle, Search, Mail, Bot, ClipboardList } from "lucide-react";
import Chatbot from "./Chatbot";
import FAQDrawer from "./FAQsupport";
import ReclamationDrawer from "./ReqDrawer";
import SupportHistoryDrawer from "./SupportHistoryDrawer";
import "../css/SupportMenu.css";

const SupportDropdown = () => {
  const [isOpenc, setIsOpenc] = useState(false);
  const { t } = useTranslation();

  const [showSupportMenu, setShowSupportMenu] = useState(false);
  const [reqshow, setReqshow] = useState(false);
  const [showFAQModal, setShowFAQModal] = useState(false);
  const [showSupportHistory, setShowSupportHistory] = useState(false);

  const toggleSupportMenu = () => {
    setShowSupportMenu(!showSupportMenu);
  };

  const handleSupportOption = (option) => {
    setShowSupportMenu(false);
    switch (option) {
      case "ai-support":
        setIsOpenc(true);
        break;
      case "faq":
        setShowFAQModal(true);
        break;
      case "reclamation":
        setReqshow(true);
        break;
      case "history":
        setShowSupportHistory(true);
        break;
      default:
        break;
    }
  };

  const handleOptionKeyDown = (event, option) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      handleSupportOption(option);
    }
  };

  return (
    <div className="sf-support-root">
      <button
        className="sf-support-floating-button"
        onClick={toggleSupportMenu}
        aria-expanded={showSupportMenu}
        aria-label={t("support", "Support")}
        title={t("support", "Support")}
      >
        <MessageCircle size={20} className="sf-support-chat-icon-bounce" />
      </button>

      {showSupportMenu && (
        <>
          <div className="sf-support-dropdown-menu" role="menu">
            <div className="sf-support-dropdown-header">
              <div className="sf-support-dropdown-title">
                {t("Start a conversation")}
              </div>
              <p className="sf-support-dropdown-subtitle">
                {t("What channel do you prefer?")}
              </p>
            </div>

            <div
              className="sf-support-option"
              role="menuitem"
              tabIndex={0}
              onClick={() => handleSupportOption("ai-support")}
              onKeyDown={(e) => handleOptionKeyDown(e, "ai-support")}
            >
              <div className="sf-support-option-icon">
                <Bot size={16} />
              </div>
              <div className="sf-support-option-content">
                <h6>{t("AI-Support")}</h6>
                <p>{t("Receive instant support.")}</p>
              </div>
            </div>

            <div
              className="sf-support-option"
              role="menuitem"
              tabIndex={0}
              onClick={() => handleSupportOption("faq")}
              onKeyDown={(e) => handleOptionKeyDown(e, "faq")}
            >
              <div className="sf-support-option-icon">
                <Search size={16} />
              </div>
              <div className="sf-support-option-content">
                <h6>{t("faq")}</h6>
                <p>{t("Search our Support Center.")}</p>
              </div>
            </div>

            <div
              className="sf-support-option"
              role="menuitem"
              tabIndex={0}
              onClick={() => handleSupportOption("reclamation")}
              onKeyDown={(e) => handleOptionKeyDown(e, "reclamation")}
            >
              <div className="sf-support-option-icon">
                <Mail size={16} />
              </div>
              <div className="sf-support-option-content">
                <h6>{t("Reclamation")}</h6>
                <p>{t("Submit a complaint or reclamation form.")}</p>
              </div>
            </div>

            <div
              className="sf-support-option"
              role="menuitem"
              tabIndex={0}
              onClick={() => handleSupportOption("history")}
              onKeyDown={(e) => handleOptionKeyDown(e, "history")}
            >
              <div className="sf-support-option-icon">
                <ClipboardList size={16} />
              </div>
              <div className="sf-support-option-content">
                <h6>{t("my_support_requests", "Mes demandes")}</h6>
                <p>
                  {t(
                    "my_support_requests_hint",
                    "Suivre les statuts et les réponses de l’équipe.",
                  )}
                </p>
              </div>
            </div>
          </div>

          <div
            className="position-fixed top-0 start-0 w-100 h-100"
            style={{ zIndex: -1 }}
            onClick={() => setShowSupportMenu(false)}
          />
        </>
      )}

      {showFAQModal && (
        <FAQDrawer
          isOpen={showFAQModal}
          onClose={() => setShowFAQModal(false)}
        />
      )}

      {isOpenc && <Chatbot setIsOpen={setIsOpenc} isOpen={isOpenc} />}
      {reqshow && (
        <ReclamationDrawer isOpen={reqshow} onClose={() => setReqshow(false)} />
      )}
      {showSupportHistory && (
        <SupportHistoryDrawer
          isOpen={showSupportHistory}
          onClose={() => setShowSupportHistory(false)}
        />
      )}
    </div>
  );
};

export default SupportDropdown;
